/**
 * <QuestStepRowSkeleton> — la forme d'une étape de quête pendant le chargement.
 *
 * La pastille, la phrase, et la chip de ce que l'étape rapporte : la géométrie est celle de
 * `<QuestStepRow>`, importée et non recopiée.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { CardListRow } from "../CardList"
import { QUEST_STEP_MARKER_SIZE } from "./QuestStepRow"

export type QuestStepRowSkeletonProps = {
    /** L'étape rapporte quelque chose : une étape à venir. Défaut `true`. */
    reward?: boolean
}

export function QuestStepRowSkeleton(props: QuestStepRowSkeletonProps) {
    const { reward = true } = props

    return (
        <CardListRow>
            <Row gap="3" align="start">
                <Skeleton shape="circle" size={QUEST_STEP_MARKER_SIZE} />
                <Stack gap="2" style={styles.body}>
                    <Skeleton textSize="text-md" width="85%" />
                    {reward && <Skeleton shape="chip" width={96} />}
                </Stack>
            </Row>
        </CardListRow>
    )
}

const styles = StyleSheet.create(() => ({
    body: { flex: 1, flexShrink: 1, minWidth: 0 },
}))
